import React, { useState, useEffect, useRef } from 'react';
import { X, Download, Printer, Upload } from 'lucide-react';
import apiService from '../../../config';
import { useSignature } from '../../../DigitalSignature/UseSignatue';
import SignaturePad from '../../../DigitalSignature/SignaturePad';

const HighwayAnusuchi6 = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [landholdingData, setLandholdingData] = useState([]);
  const [fetching, setFetching] = useState(true);
  const [locationInfo, setLocationInfo] = useState({ village: '', taluka: '', district: '' });
  const [InchargeAddress, setInchargeAddress] = useState("");
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [currentProposalId, setCurrentProposalId] = useState(null);
  const [officerName, setOfficerName] = useState(null);
  const [date, setDate] = useState(null);
  const [proposalNo, setProposalNo] = useState('');
  const [projectName, setProjectName] = useState('');
  const [signatureFile, setSignatureFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [regionalInchargeName, setRegionalInchargeName] = useState("");
  const [regionalInchargeDesignation, setRegionalInchargeDesignation] = useState("");
  const [InchargeName, setInchargeName] = useState("");
  const [InchargeDesignation, setInchargeDesignation] = useState("");
  const [isSignAvailable, setIsSignAvailable] = useState(false);
  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${today.getFullYear()}`;
  const userData = JSON.parse(localStorage.getItem('userData'));
  const userRole = parseInt(userData?.data?.user_role || userData?.user_role, 10);
  const userName = userData?.full_name || 'N/A';
  const userDesi = userData?.designation || 'N/A';
  const [uploadStatus, setUploadStatus] = useState("idle");
  const documentRef = useRef(null);
  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [pdfForSigning, setPdfForSigning] = useState(null);
  const { signDocument } = useSignature();
  // "idle" | "uploading" | "success" | "error"
  const [uploadError, setUploadError] = useState("");
  const fetchLandholdings = async () => {
    try {
      setFetching(true);
      setIsLoading(true);

      const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
      const projectIdFromStorage = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem('currentProposalId') || currentProposalId;

      if (!projectIdFromStorage || !proposalId) {
        console.warn('Missing projectId or proposalId for fetchLandholdings');
        setFetching(false);
        setIsLoading(false);
        return;
      }

      // API Call
      const result = await apiService.getLandHolding(projectIdFromStorage, { proposalId });

      if (result?.status === 200 && Array.isArray(result.data)) {
        setLandholdingData(result.data);
      } else {
        console.warn('No landholding data found:', result);
      }
      // ✅ Extract project name and proposal number if provided
      // if (result.proposalData && result.proposalData.length > 0) {
      //   setProposalNo(result.proposalData[0].acquisition_proposal_no || '');
      //   setProjectName(result.proposalData[0].project_name || '');
      // }

      if (result.proposalData && result.proposalData.length > 0) {
        const proposal = result.proposalData[0];
        setProposalNo(proposal.acquisition_proposal_no || '');
        setProjectName(proposal.project_name || '');
        setInchargeAddress(proposal.acquisition_incharge_address || '');
      }


      // ✅ Extract district, taluka, village
      if (result.data.length > 0) {
        const first = result.data[0];
        setLocationInfo({
          village: first.village_name || first.VillageName || '',
          taluka: first.tehsil_name || first.taluka_name || '',
          district: first.dist_name || '',
        });
      }
    } catch (err) {
      console.error('Error fetching landholdings:', err);
    } finally {
      setFetching(false);
      setIsLoading(false);
    }
  };


  // Project Id
  useEffect(() => {
    const getProjectInfo = () => {
      const currentProjectData = localStorage.getItem('currentProjectData');
      if (currentProjectData) {
        try {
          const projectData = JSON.parse(currentProjectData);
          return {
            id: projectData.project_id || projectData.id,
            name: projectData.project_name || projectData.name
          };
        } catch (e) {
          console.error('Error parsing current project data (currentProjectData):', e);
        }
      }

      const selectedProject = localStorage.getItem('selectedProject');
      if (selectedProject) {
        try {
          const project = JSON.parse(selectedProject);
          return {
            id: project.project_id || project.id,
            name: project.project_name || project.name
          };
        } catch (e) {
          console.error('Error parsing selected project (selectedProject):', e);
        }
      }

      const userData = localStorage.getItem('userData');
      if (userData) {
        try {
          const user = JSON.parse(userData);
          const projectId = user.data?.project_id || user.project_id;
          const projectName = user.data?.project_name || user.project_name || 'Unknown Project';
          return {
            id: projectId,
            name: projectName
          };
        } catch (e) {
          console.error('Error parsing user data (userData):', e);
        }
      }
      return { id: null, name: null };
    };
    const storedProposal = JSON.parse(localStorage.getItem('selectedProposal') || '{}');
    if (storedProposal?.acquisition_regional_incharge_name) {
      setRegionalInchargeName(storedProposal.acquisition_regional_incharge_name);
    }
    if (storedProposal?.acquisition_regional_incharge_designation) {
      setRegionalInchargeDesignation(storedProposal.acquisition_regional_incharge_designation);
    }
    if (storedProposal?.acquisition_incharge_designation) {
      setInchargeDesignation(storedProposal.acquisition_incharge_designation);
    }
    if (storedProposal?.acquisition_incharge_name) {
      setInchargeName(storedProposal.acquisition_incharge_name);
    }
    const projectInfo = getProjectInfo();
    setCurrentProjectId(projectInfo.id);
    console.log('Current Project Info:', projectInfo);
  }, []);

  // Add this useEffect after your state declarations and before the existing useEffects
  useEffect(() => {
    const loadProposalData = async () => {
      try {
        const userData = JSON.parse(localStorage.getItem("userData"));
        const project = JSON.parse(localStorage.getItem("selectedProject"));
        const projectId = project?.id || project?.project_id;
        const proposalId = userData?.default_proposal || userData?.proposal_id || localStorage.getItem('currentProposalId');

        if (projectId && proposalId) {
          const result = await apiService.getProposalById(projectId, proposalId);
          if (result && result.status === 200) {
            const proposal = Array.isArray(result.data)
              ? result.data[0]
              : result.data;

            // ✅ Set all officer information from API
            setRegionalInchargeName(
              proposal?.acquisition_regional_incharge_name || ""
            );
            setRegionalInchargeDesignation(
              proposal?.acquisition_regional_incharge_designation || ""
            );
            setInchargeName(
              proposal?.acquisition_incharge_name || ""
            );
            setInchargeDesignation(
              proposal?.acquisition_incharge_designation || ""
            );
            setInchargeAddress(
              proposal?.acquisition_incharge_address || ""
            );
          }
        }
      } catch (error) {
        console.error("Error loading proposal data:", error);
      }
    };

    loadProposalData();
  }, []);

  const handleUploadSignature = async (file) => {
    try {
      setUploadStatus("uploading");
      setUploadError("");

      const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
      const projectIdFromStorage = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem('currentProposalId')

      if (!projectIdFromStorage || !proposalId) {
        setUploadStatus("error");
        setUploadError("Missing projectId or proposalId");
        alert("Missing projectId or proposalId");
        return;
      }

      const BRIDGE_URL = "http://127.0.0.1:8000";

      // Show dialog first (always open modal)
      const signatureParams = await showDigitalSignatureDialog();
      if (!signatureParams) {
        setUploadStatus("idle");
        return; // User cancelled
      }

      // Check bridge app status AFTER modal
      try {
        const healthCheck = await fetch(`${BRIDGE_URL}/health`, { method: "GET" });
        if (!healthCheck.ok) {
          throw new Error("Bridge app not accessible");
        }
      } catch (error) {
        setUploadStatus("error");
        setUploadError("Digital signature bridge app is not running. Please start it first.");
        alert("Digital signature bridge app is not running. Please start it first.");
        return;
      }

      // Build FormData according to FastAPI API
      const formData = new FormData();
      formData.append("pdf_file", file);
      formData.append("token_name", signatureParams.tokenName);
      formData.append("pin", signatureParams.pin);
      formData.append("pages", signatureParams.pages); // ✅ string (e.g. "all" or "1-3,5")
      formData.append("position", signatureParams.position); // ✅ "Left" / "Right"
      formData.append("place_text", signatureParams.placeText || "");

      const bridgeResponse = await fetch(`${BRIDGE_URL}/sign-pdf/`, {
        method: "POST",
        body: formData,
      });

      if (!bridgeResponse.ok) {
        const errorData = await bridgeResponse.json().catch(() => ({ detail: "Unknown error" }));
        throw new Error(errorData.detail || `Bridge app error: ${bridgeResponse.status}`);
      }

      const signedPdfBlob = await bridgeResponse.blob();
      const signedPdfFile = new File([signedPdfBlob], `signed_${file.name}`, { type: "application/pdf" });

      const serverResponse = await apiService.postAddSignaturePDF(
        projectIdFromStorage,
        proposalId,
        "parishisht6",
        signedPdfFile
      );

      if (serverResponse?.status === 200) {
        setUploadStatus("success");
        alert("PDF digitally signed and uploaded successfully!");

        const sectionRes = await apiService.getSectionFile(projectIdFromStorage, proposalId, "anusuchi2");
        if (sectionRes?.isSignAvailable && sectionRes?.data?.length > 0) {
          setPreviewUrl(sectionRes.data[0].file_path);
        }
      } else {
        setUploadStatus("error");
        setUploadError(`Failed to upload signed PDF: ${serverResponse?.message || "Unknown error"}`);
        alert(`Failed to upload signed PDF: ${serverResponse?.message || "Unknown error"}`);
      }

    } catch (error) {
      setUploadStatus("error");
      setUploadError(error.message);
      console.error("Digital signature error:", error);

      if (error.message.includes("PIN is incorrect")) {
        alert("The provided PIN is incorrect. Please try again.");
      } else if (error.message.includes("token found")) {
        alert("No PKCS#11 token found. Please connect your digital signature device.");
      } else if (error.message.includes("Bridge app not running")) {
        alert("Digital signature bridge app is not running. Please start it first.");
      } else {
        alert(`Error during digital signing: ${error.message}`);
      }
    }
  };

  // Updated dialog to match Python backend
  const showDigitalSignatureDialog = () => {
    return new Promise((resolve) => {
      const modal = document.createElement("div");
      modal.style.cssText = `
      position: fixed; top: 0; left: 0; width: 100%; height: 100%;
      background: rgba(0,0,0,0.5); display: flex; align-items: center;
      justify-content: center; z-index: 1000;
    `;

      const dialog = document.createElement("div");
      dialog.style.cssText = `
      background: white; padding: 20px; border-radius: 8px;
      max-width: 400px; width: 90%;
    `;

      dialog.innerHTML = `
      <h3 style="margin-top: 0;">Digital Signature Parameters</h3>
      <form id="signatureForm">
        <div style="margin-bottom: 15px;">
          <label style="display:block; margin-bottom:5px;">Token Name:</label>
          <select id="tokenName" required 
            style="width:100%; padding:8px; border:1px solid #ccc; border-radius:4px;">
            <option value="">Select Token</option>
            <option value="ProxKey">ProxKey</option>
            <option value="ePass2003 Auto">ePass2003 Auto</option>
            <option value="Moser Baer">Moser Baer</option>
            <option value="Safenet/Gemalto">Safenet/Gemalto</option>
          </select>
        </div>

        <div style="margin-bottom: 15px;">
          <label style="display:block; margin-bottom:5px;">PIN:</label>
          <input type="password" id="pin" required 
            style="width:100%; padding:8px; border:1px solid #ccc; border-radius:4px;">
        </div>

        <div style="margin-bottom: 15px;">
          <label style="display:block; margin-bottom:5px;">Pages (e.g., "all", "1-3,5"):</label>
          <input type="text" id="pages" value="all" required
            style="width:100%; padding:8px; border:1px solid #ccc; border-radius:4px;">
        </div>

        <div style="margin-bottom: 15px;">
          <label style="display:block; margin-bottom:5px;">Signature Position:</label>
          <select id="position" 
            style="width:100%; padding:8px; border:1px solid #ccc; border-radius:4px;">
            <option value="Right">Right</option>
            <option value="Left">Left</option>
          </select>
        </div>

        <div style="margin-bottom: 20px;">
          <label style="display:block; margin-bottom:5px;">Place Text (Optional):</label>
          <input type="text" id="placeText" placeholder="e.g., Mumbai, India"
            style="width:100%; padding:8px; border:1px solid #ccc; border-radius:4px;">
        </div>

        <div style="display:flex; gap:10px; justify-content:flex-end;">
          <button type="button" id="cancelBtn" 
            style="padding:8px 16px; border:1px solid #ccc; background:white; border-radius:4px; cursor:pointer;">
            Cancel
          </button>
          <button type="submit" 
            style="padding:8px 16px; border:none; background:#007bff; color:white; border-radius:4px; cursor:pointer;">
            Sign PDF
          </button>
        </div>
      </form>

    `;

      modal.appendChild(dialog);
      document.body.appendChild(modal);

      const form = dialog.querySelector("#signatureForm");
      const cancelBtn = dialog.querySelector("#cancelBtn");

      form.addEventListener("submit", (e) => {
        e.preventDefault();
        const params = {
          tokenName: dialog.querySelector("#tokenName").value,
          pin: dialog.querySelector("#pin").value,
          pages: dialog.querySelector("#pages").value.trim() || "all",
          position: dialog.querySelector("#position").value,
          placeText: dialog.querySelector("#placeText").value,
        };
        document.body.removeChild(modal);
        resolve(params);
      });

      cancelBtn.addEventListener("click", () => {
        document.body.removeChild(modal);
        resolve(null);
      });

      modal.addEventListener("click", (e) => {
        if (e.target === modal) {
          document.body.removeChild(modal);
          resolve(null);
        }
      });
    });
  };



  // const handleFileUpload = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setSignatureFile(file);
  //     setPreviewUrl(URL.createObjectURL(file));
  //     handleUploadSignature(file);
  //   }
  // };

  const handleUploadedFile = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    // ✅ open uploaded file in signature modal
    setPdfForSigning(file);
    setShowSignaturePad(true);
  };

  const handleViewFile = () => {
    if (previewUrl) {
      window.open(previewUrl, "_blank");
    }
  }

  // Proposal id
  useEffect(() => {
    const getProposalInfo = () => {
      const currentProposal = JSON.parse(localStorage.getItem('userData') || '{}');

      if (currentProposal) {
        try {
          return {
            proposalId: currentProposal?.data?.default_proposal ||
              currentProposal?.data?.proposal_id ||
              currentProposal?.default_proposal ||
              currentProposal?.proposal_id ||
              null
          }
        } catch (e) {
          console.error('Error parsing current project data (getProposalInfo):', e);
        }
      }
      return { proposalId: null };
    };

    const proposalInfo = getProposalInfo();
    setCurrentProposalId(proposalInfo.proposalId);
    console.log('Current Project-Proposal Info:', proposalInfo);
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const dateObj = new Date(dateString);
    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    const init = async () => {
      if (!currentProjectId || !currentProposalId) return;
      setFetching(true);

      try {
        const sectionRes = await apiService.getSectionFile(
          currentProjectId,
          currentProposalId,
          'parishisht6'
        );

        if (sectionRes?.isSignAvailable && sectionRes?.data?.length > 0) {
          setIsSignAvailable(true);
          setPreviewUrl(sectionRes.data[0].file_path);
          setSignatureFile(null);
        }

        // Always fetch landholding data
        await fetchLandholdings();
      } catch (e) {
        console.error('Error during section pre-check:', e);
        await fetchLandholdings();
      } finally {
        setFetching(false);
      }
    };

    init();
  }, [currentProjectId, currentProposalId]);


  const handlePrint = () => {
    const printContent = documentRef.current?.innerHTML;
    if (!printContent) {
      alert("No content available to print.");
      return;
    }

    const win = window.open("", "", "height=900,width=1200");
    win.document.write(`
      <html>
      <head>
        <title>जिगांव प्रकल्प अहवाल</title>
        <style>
          @page {
            size: A4 portrait;
            margin-top: 0.19in;
            margin-bottom: 0.25in;
            margin-left: 0.81in;
            margin-right: 0.5in;
          }
            
          body {
            font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
            -webkit-print-color-adjust: exact;
            color-adjust: exact;
            background: white;
          }

          h2 {
            font-size: 18px;
            text-align: center;
            margin-bottom: 12px;
            font-weight: bold;
          }

          .text-center { text-align: center; }
          .font-bold { font-weight: bold; }
          .mr-4 {padding: 0.5rem; }
          .underline{text-decoration: underline;}
          .mt-8{margin-top: 20px}

          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 13px;
            page-break-inside: auto;
          }
          th, td {
            border: 1px solid #000;
            padding: 6px 8px;
          }
          th {
            background-color: #e5e7eb !important; /* gray-200 */
            font-weight: bold;
          }
          tr:nth-child(even) {
            background-color: #f9f9f9;
          }

          /* Hide buttons or unnecessary UI in print */
          button, .no-print { display: none !important; }

          /* Ensure long tables split nicely */
          thead { display: table-header-group; }
          tfoot { display: table-footer-group; }

        </style>
      </head>
      <body>
        <div class="document-container">
          ${printContent}
        </div>
      </body>
    </html>
  `);


    win.document.close();
    win.print();
  };

  const handleDownloadWord = async () => {
    if (previewUrl) {
      // 🔹 Open same file in new tab but force .doc download
      const link = document.createElement("a");
      link.href = previewUrl;
      link.target = "_blank";
      link.download = "अनुसूची-२.doc";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    }

    setIsLoading(true);
    const htmlContent = `
      <html>
        <head>
          <meta charset="utf-8">
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            table { border-collapse: collapse; width: 100%; margin: 20px 0; }
            th, td { border: 1px solid black; padding: 8px; text-align: center; }
            th { background-color: #f0f0f0; font-weight: bold; }
            .header { text-align: center; margin-bottom: 20px; }
            .signature-section { margin-top: 40px; text-align: right; }
            .signature { margin: 20px 0; }
            .heading {border-bottom:2px solid Black}
            .Location{font-weight:bold}
          </style>
        </head>
        <body>
          <div class="header">
          <div class="header-top">
         
        </div>
            <h2>परिशिष्ट-6</h2>
            <div> <span class="right">प्रकल्प नाव: ${projectName || '-'} </span>
          <span class="left">प्रस्ताव नाव:  ${proposalNo || '-'}</span>
          </div>
            <div class="Location">
                 <span className='mr-4'>मौजे: ${locationInfo.village}</span>
                 <span className='mr-4'>तालुका: ${locationInfo.taluka}</span>
                 <span className='mr-4'>जिल्हा: ${locationInfo.district}</span>
               </div>
              <h3 class="heading">प्रकल्पाच्या आखणीमध्ये समाविष्ट जमिनीच्या चतु:सिमा दर्शविणारा तक्ता</h3>

          </div>
          <table>
            <thead>
              <tr>
                <th>अ.क्र.</th>
                <th>गट/सर्व्हे क्रमांक</th>
                <th colspan="4">भूसंपादन क्षेत्राच्या चतुःसिमेस असलेले गट/सर्व्हे क्रमांक</th>
              </tr>
              <tr>
                <th></th>
                <th></th>
                <th>पूर्व</th>
                <th>पश्चिम</th>
                <th>उत्तर</th>
                <th>दक्षिण</th>
              </tr>
            </thead>
            <tbody>
              ${surveyKramankData.map((row, index) => `
                <tr>
                  <td>${index + 1}</td>
                  <td>${row.survey_no || '-'}</td>
                  <td>${row.east || '-'}</td>
                  <td>${row.west || '-'}</td>
                  <td>${row.north || '-'}</td>
                  <td>${row.south || '-'}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>

           <table>
            <thead>
              <tr>
                <th>अ.क्र.</th>
                <th>गट/सर्व्हे क्रमांक</th>
                <th colspan="4">भूसंपादन क्षेत्राच्या चतुःसिमेस असलेले गट/सर्व्हे क्रमांक</th>
              </tr>
              <tr>
                <th></th>
                <th></th>
                <th>पूर्व</th>
                <th>पश्चिम</th>
                <th>उत्तर</th>
                <th>दक्षिण</th>
              </tr>
            </thead>
            <tbody>
              ${gharKramankData.map((row, index) => `
                <tr>
                  <td>${index + 1}</td>
                  <td>${row.survey_no || '-'}</td>
                  <td>${row.east || '-'}</td>
                  <td>${row.west || '-'}</td>
                  <td>${row.north || '-'}</td>
                  <td>${row.south || '-'}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>

          <div style="width: 100%; margin-top: 20px; display: table; table-layout: fixed;">
  <div style="display: table-cell; vertical-align: top; width: 50%; text-align: left; padding-right: 10px;">
    <p style="margin: 2px 0;">दिनांक: ${formattedDate}</p>
    <p style="margin: 2px 0;">ठिकाण: ${locationInfo.village}</p>
    // <p style="margin: 2px 0;">तयार करणारे: ${userName || ''}(${userDesi || ''})</p>
  </div>
  <div style="display: table-cell; vertical-align: bottom; width: 25%; text-align: left; line-height: 1.4; margin-top: 30px; padding-top: 60px; page-break-inside: avoid;">
    <p style="margin: 2px 0;">${regionalInchargeName ? `(${regionalInchargeName})` : ""}</p>
    <p style="margin: 2px 0;">${regionalInchargeDesignation || ""}</p>
  </div>
  <div style="display: table-cell; vertical-align: bottom; width: 25%; text-align: right; line-height: 1.4; margin-top: 20px; padding-top: 60px; page-break-inside: avoid;">
    <p style="margin: 2px 0;">${InchargeName ? `(${InchargeName})` : ""}</p>
    <p style="margin: 2px 0;">${InchargeDesignation || ""}</p>
    
  </div>
</div>

        </body>
      </html>`;

    const blob = new Blob([htmlContent], {
      type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'परिशिष्ट 6.doc';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    setIsLoading(false);
  };

  const surveyTypeGroup = ["सर्व्हे क्रमांक", "गट क्रमांक", "प्लॉट क्रमांक"];

  const surveyKramankData = landholdingData.filter(item =>
    surveyTypeGroup.includes(item.survey_type)
  );

  const gharKramankData = landholdingData.filter(
    item => item.survey_type === "घर क्रमांक."
  );


  return (
    <div className="p-4 border-2">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center space-x-3">
          <button onClick={handlePrint} className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
            <Printer size={18} />
            <span>Print</span>
          </button>
          <button onClick={handleDownloadWord} className="flex items-center space-x-2 px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:opacity-50">
            <Download size={18} />
            <span>Download Word</span>
          </button>

          {/* Upload Signature - Conditional Rendering */}
          {/* {!previewUrl ? ( */}
          <button className="relative">
            <label className="flex items-center space-x-2 px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 cursor-pointer">
              <Upload size={18} />
              <span>Upload Signature</span>
              <input
                type="file"
                accept="application/pdf,image/*"
                className="hidden"
                onChange={handleUploadedFile}
              />
            </label>
          </button>
          {/* ) : (
          <button
            onClick={handleViewFile}
            className="flex items-center space-x-2 px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700"
          >
            View File
          </button>
        )} */}
        </div>
      </div>

      {previewUrl ? (
        // Show PDF directly if signed file exists
        <div className="w-full bg-white p-4 rounded-lg">
          <iframe
            src={`${previewUrl}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
            // src={`${previewUrl}`}
            title="Parishtisht-6 PDF"
            width="100%"
            height="800px"
            style={{
              border: "none",
              borderRadius: "8px",
              boxShadow: "none",
              outline: "none",
              margin: "0",
              padding: "0"
            }}
            frameBorder="0"
            seamless
          />
        </div>
      ) : (
        <div ref={documentRef} className="p-6">
          {(isLoading || fetching) ? (
            <div className="flex justify-center items-center h-96">
              <p className="text-lg text-gray-600">isLoading...</p>
            </div>
          ) : (
            <>
              <div className="text-center mb-4">


                <h3 className="text-center font-bold mb-2">परिशिष्ट-6 </h3>
                <h3 className="text-center font-bold mb-2">
                  प्रकल्प नाव: {projectName} | प्रस्ताव नाव/नाव: {proposalNo}
                </h3>
                <p className="center-text font-bold mb-2">
                  <span className='mr-4'>मौजे: {locationInfo.village}</span>
                  <span className='mr-4'>तालुका: {locationInfo.taluka}</span>
                  <span className='mr-4'>जिल्हा: {locationInfo.district}</span>
                  <h2 className="text-md font-semibold my-3 underline">प्रकल्पाच्या आखणीमध्ये समाविष्ट जमिनीच्या चतु:सिमा दर्शविणारा तक्ता</h2>
                </p>
              </div>

              <div className="overflow-x-auto">
                {surveyKramankData.length > 0 &&
                  <table className="w-full border-collapse border-2 border-black">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="border border-black p-3 font-bold text-center" rowSpan={2}>अ.<br />क्र.</th>
                        <th className="border border-black p-3 font-bold text-center" rowSpan={2}>गट/सर्व्हे क्रमांक</th>
                        <th className="border border-black p-3 font-bold text-center" colSpan={4}>भूसंपादन क्षेत्राच्या चतुःसिमेस असलेले गट/सर्व्हे क्रमांक</th>
                      </tr>
                      <tr className="bg-gray-100">
                        <th className="border border-black p-3 font-bold text-center">पूर्व</th>
                        <th className="border border-black p-3 font-bold text-center">पश्चिम</th>
                        <th className="border border-black p-3 font-bold text-center">उत्तर</th>
                        <th className="border border-black p-3 font-bold text-center">दक्षिण</th>
                      </tr>
                    </thead>
                    <tbody>
                      {surveyKramankData.map((row, index) => (
                        <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                          <td className="border border-black p-2 text-center">{index + 1}</td>
                          <td className="border border-black p-2 text-center">{row.survey_no || '-'}</td>
                          <td className="border border-black p-2 text-center">{row.east || '-'}</td>
                          <td className="border border-black p-2 text-center">{row.west || '-'}</td>
                          <td className="border border-black p-2 text-center">{row.north || '-'}</td>
                          <td className="border border-black p-2 text-center">{row.south || '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                }

                {gharKramankData.length > 0 &&
                  <table className="w-full border-collapse border-2 border-black mt-8">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="border border-black p-3 font-bold text-center" rowSpan={2}>अ.<br />क्र.</th>
                        <th className="border border-black p-3 font-bold text-center" rowSpan={2}>घर क्रमांक</th>
                        <th className="border border-black p-3 font-bold text-center" colSpan={4}>भूसंपादन क्षेत्राच्या चतुःसिमेस असलेले घर क्रमांक</th>
                      </tr>
                      <tr className="bg-gray-100">
                        <th className="border border-black p-3 font-bold text-center">पूर्व</th>
                        <th className="border border-black p-3 font-bold text-center">पश्चिम</th>
                        <th className="border border-black p-3 font-bold text-center">उत्तर</th>
                        <th className="border border-black p-3 font-bold text-center">दक्षिण</th>
                      </tr>
                    </thead>
                    <tbody>
                      {gharKramankData.map((row, index) => (
                        <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                          <td className="border border-black p-2 text-center">{index + 1}</td>
                          <td className="border border-black p-2 text-center">{row.survey_no || '-'}</td>
                          <td className="border border-black p-2 text-center">{row.east || '-'}</td>
                          <td className="border border-black p-2 text-center">{row.west || '-'}</td>
                          <td className="border border-black p-2 text-center">{row.north || '-'}</td>
                          <td className="border border-black p-2 text-center">{row.south || '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                }
              </div>

              <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                {/* Left side */}
                <div style={{ textAlign: "left" }}>
                  <p>दिनांक: {formattedDate}</p>
                  <p>ठिकाण: {InchargeAddress || locationInfo.village}</p>
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                {/* Right side */}

                <div style={{ textAlign: "center", marginTop: "150px" }}>
                  <p> {regionalInchargeName ? ` (${regionalInchargeName})` : ""}</p>
                  <p className='text-center'> {regionalInchargeDesignation ? ` ${regionalInchargeDesignation}` : ""}</p>
                </div>
                <div style={{ textAlign: "center", marginTop: "150px" }}>
                  <p> {InchargeName ? ` (${InchargeName})` : ""}</p>
                  <p className='text-center'> {InchargeDesignation ? ` ${InchargeDesignation}` : ""}</p>
                </div>
              </div>
            </>
          )}
        </div>
      )}

      {showSignaturePad && pdfForSigning && (
        <SignaturePad
          pdfFile={pdfForSigning}
          onSign={(signaturesArray) => {
            setShowSignaturePad(false);

            signDocument(pdfForSigning, signaturesArray).then(async (signedPdf) => {
              const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
              const projectId = selectedProject?.id || selectedProject?.project_id;
              const proposalId = localStorage.getItem("currentProposalId");

              await apiService.postAddSignaturePDF(
                projectId,
                proposalId,
                "parishisht1",
                signedPdf
              );

              const sectionRes = await apiService.getSectionFile(
                projectId,
                proposalId,
                "parishisht1"
              );

              if (sectionRes?.isSignAvailable) {
                setPreviewUrl(sectionRes.data[0].file_path);
              }

              setPdfForSigning(null);
            });
          }}
          onCancel={() => {
            setShowSignaturePad(false);
            setPdfForSigning(null);
          }}
        />
      )}

    </div>
  );
};

export default HighwayAnusuchi6;